import { useCallback } from 'react';
import styled from 'styled-components';
import { IconButton, Stack, SxProps, Theme } from '@mui/material';
import { ReactComponent as ContentCopy } from '../../assets/copy.svg';
import { FlexColumn } from '../Flex';
import OverflowTooltip from '../OverflowTooltip';
import { radius, space } from '../../style/utils';

const Wrapper = styled(Stack)<{ $fullWidth?: boolean }>`
  align-items: center;
  padding: ${space(0, 'smMinus')};
  background-color: ${({ theme }) => theme.palette.surface.strong};
  border-radius: ${radius('xxs')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '250px')};
  gap: ${space('xs')};
`;

const ButtonWrapper = styled(FlexColumn)`
  height: 100%;
  justify-content: flex-end;
  margin-right: 0;
  margin-left: auto;
`;

const Copy = styled(IconButton)`
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;

  & svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.palette.accent.link};
  }

  :hover {
    background: ${({ theme }) => theme.palette.surface.emphasis};
  }
`;

type Props = {
  value: string;
  autoTooltipPlacement?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  onOpenSnackbar?: (message: string) => void;
};

const OverflowClipboard = ({
  value,
  autoTooltipPlacement,
  fullWidth,
  sx,
  onOpenSnackbar,
}: Props) => {
  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(value);
    onOpenSnackbar?.('Copied to clipboard');
  }, [value, onOpenSnackbar]);

  return (
    <Wrapper direction="row" sx={sx} $fullWidth={fullWidth}>
      <OverflowTooltip autoTooltipPlacement={autoTooltipPlacement}>
        {value}
      </OverflowTooltip>
      <ButtonWrapper>
        <Copy onClick={handleClick}>
          <ContentCopy width={16} />
        </Copy>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default OverflowClipboard;
